import Carousel from '../components/Carousel'
import Banner from '../components/Banner'
import { discountVoucherHref, tripDotComHref, apMTradingHref, exchangeHref, irisHref } from '../constants/href';
import { maincardImage } from '../assets/images';

function MainCardCarousel() {
  const adBannerArray = [
    <Banner key={discountVoucherHref.name} gaPage='Main Card' name={discountVoucherHref.name} eventHref={discountVoucherHref.href} image={maincardImage.discountVoucherMain}/>
  ]
  
  const shuffledBanner = adBannerArray.sort(() => Math.random() - 0.5);

  return (
    <Carousel gaPage='Main Card'>
      { shuffledBanner }
      <Banner key={irisHref.name} gaPage='Main Card' name={irisHref.name} eventHref={irisHref.href} image={maincardImage.irisMain}/>
      <Banner key={apMTradingHref.name} gaPage='Main Card' name={apMTradingHref.name} eventHref={apMTradingHref.href} image={maincardImage.apMTradingMain}/>
      <Banner key={exchangeHref.name} gaPage='Main Card' name={exchangeHref.name} eventHref={exchangeHref.href} image={maincardImage.exchangeMain}/>
      <Banner key={tripDotComHref.name} gaPage='Main Card' name={tripDotComHref.name} eventHref={tripDotComHref.href} image={maincardImage.tripDotComMain}/>
    </Carousel>
  )
}

export default MainCardCarousel;

